exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-cookie-policy {\n  color: #fff !important; }\n  .fmcy-cookie-policy h1, .fmcy-cookie-policy h2, .fmcy-cookie-policy h3 {\n    font-family: \"bebasneue\", \"Arial\", sans-serif !important;\n    color: #fff !important; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/entry-flow/entry-flow-modal/content/cookie-policy.scss
 ** module id = 540
 ** module chunks = 1 30 94 178
 **/